/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createFontDataSchema = z.object({
	media: z.unknown(),
	displayName: z.string().nullable().optional(),
	weight: z.string().nullable().optional(),
	style: z.string().nullable().optional(),
})

export type CreateFontDataSchema = z.infer<typeof createFontDataSchema>
